import { openConfirmModal } from "@mantine/modals";
import {
	FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfig,
	FxIdDomainSettingsUrlOpenMethod
} from "../../../../../../Api/gen";
import { openIframeModal } from "../../../../../../Components/Modals";
import { getDocsUrlFromGameConfigAndBranding } from "../../../../../../Utils/Functions";
import { IframeType } from "../../../../Hooks";
import { ReactI18NextChild, TFunction } from "react-i18next";
import { logout } from "../../../../../../Api/Auth";

export const getGameUrl = () => new URL(window.location.pathname, window.location.origin);

export const openLogoutModal = (t: TFunction, children: ReactI18NextChild | Iterable<ReactI18NextChild>) => {
	return openConfirmModal({
		title: t("logout_modal.title"),
		size: "sm",
		children,
		labels: { confirm: t("button_logout"), cancel: t("button_cancel") },
		onConfirm: () =>
			void logout()
				.then(() => window.location.reload())

				.catch((e) => log.error("Error in logout!", e))
	});
};

// Функция для обработки клика по ссылке на документацию TOS и PP
export const handleTosPpDocsLinkClick = (url: string, method: FxIdDomainSettingsUrlOpenMethod) => {
	if (method === FxIdDomainSettingsUrlOpenMethod.NewPage) {
		window.open(url, "_blank", "noopener,noreferrer");
	} else {
		openIframeModal({ url: String(url) });
	}
};

// Функция для обработки клика по ссылке на контакты
export const handleContactsClick = (gameConfigId?: string, gameConfigAdapter?: IframeType, contactsUrl?: string) => {
	const url = String(getDocsUrlFromGameConfigAndBranding(gameConfigId, gameConfigAdapter, contactsUrl));
	openIframeModal({ url: String(url) });
};
